export { Details as default } from './Details'
